import { BaseDialog } from '../common/dialogs/BaseDialog';
import { DefaultCardsLayout } from '../common/CardsGridLayout';
import { useSelector } from 'react-redux';
import { selectFunnelMapsIsLoading, selectFunnelMapsList } from '../../reducers/funnelMapsReducer';
import { Stack } from '@mui/material';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import { SearchInput } from '../common/SearchInput';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import { useState } from 'react';
import { filterItemsBySearch } from '../../lib/filterItemsBySearch';
import { FunnelMapCardBase } from '../pages/funnel-maps/card/FunnelMapCardBase';
import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { CanvasMode } from '../sweep-canvas/canvas-types';

const ProcessSelectionDialog = ({
  closeDialog,
  onSelect,
}: {
  closeDialog: () => void;
  onSelect: (funnelMapId: string) => void;
}) => {
  const [searchText, setSearchText] = useState('');
  const funnelMaps = useSelector(selectFunnelMapsList);
  const isLoading = useSelector(selectFunnelMapsIsLoading);
  const filteredFunnelMaps = filterItemsBySearch(funnelMaps, searchText, (item) => item.name);

  return (
    <BaseDialog
      open={true}
      onClose={closeDialog}
      PaperProps={{
        sx: { width: '1202px', minHeight: '628px', height: '100%', overflow: 'hidden' },
      }}
    >
      <Stack padding="24px 0" height="100%">
        {isLoading && <CenteredCircularProgress />}
        {!isLoading && (
          <Stack gap={2} height="100%">
            <Stack direction="row" justifyContent="space-between" padding="0 24px">
              <Stack gap={0.5}>
                <Typography variant="h2" color={colors.grey[900]}>
                  Create new process agent
                </Typography>
                <Typography variant="body" color={colors.grey[900]}>
                  To create a new agent, select a process to optimize
                </Typography>
              </Stack>
              <Stack direction="row" gap={1}>
                <SearchInput
                  withFixedMagnifyingGlassIcon
                  onChange={(e) => setSearchText(e.target.value)}
                  value={searchText}
                />
                <IconButton onClick={closeDialog} variant="flat" size="large">
                  <Close />
                </IconButton>
              </Stack>
            </Stack>
            <Stack
              sx={{
                flex: 1,
                padding: '1px 24px',
                overflowY: 'auto',
              }}
            >
              <DefaultCardsLayout>
                {filteredFunnelMaps.map((funnelMap: FunnelMap) => (
                  <FunnelMapCardBase
                    key={funnelMap.id}
                    onClick={() => onSelect(funnelMap.id)}
                    funnelMap={funnelMap}
                    canvasMode={CanvasMode.PREVIEW3}
                    hasRequestedChanges={false}
                    isActive={false}
                    isPinned={false}
                  />
                ))}
              </DefaultCardsLayout>
            </Stack>
          </Stack>
        )}
      </Stack>
    </BaseDialog>
  );
};

export default ProcessSelectionDialog;
